<template>
  <div class="loginbox"
       v-loading="loading"
       element-loading-text="正在加载验证码">
    <div class="login">
      <div class="loginimg"><img src="../assets/login.png"
             alt=""></div>
      <div class="logininfo">
        <div class="productLogo"><img :src="$isWuHan ? require('../assets/loginlogo.png') : require('../assets/loginlogo-origin.png')"
               alt=""></div>
        <span class="productTitle"> 电子现金系统</span>
        <el-input type="text"
                  placeholder="账户"
                  prefix-icon="iconfont iconusername"
                  v-model="loginInfo.userName"></el-input>
        <el-input type="password"
                  placeholder="密码"
                  prefix-icon="iconfont iconpassword"
                  v-model="loginInfo.password"
                  @keyup.enter.native="login"></el-input>
        <div class="form-group"
             style="display: flex;">
          <div class="groupBox">
            <span class="codeTitle">验证码：</span>

            <input type="text"
                   v-model="code"
                   class="code"
                   @keyup.enter="login"
                   placeholder="请输入您的验证码" />
          </div>
          <img v-if="captcha"
               :src="captcha.base64Img"
               class="identify">
        </div>
        <el-button class="btn"
                   type="primary"
                   @click.prevent="login"
                   native-type="submit">登录</el-button>
      </div>
    </div>
    <div class="footer" v-if="$isWuHan">
      鄂ICP备2021008245号 武汉大悦城房地产开发有限公司
    </div>
  </div>
</template>

<script>
import { permission } from '@/router/permission'
export default {
  data () {
    return {
      loading: false,
      loginInfo: {
        userName: null,
        password: null
      },
      code: '',
      captcha: null
    }
  },
  components: {
  },
  created () {
    this.getCaptcha()
  },
  mounted () {
    localStorage.setItem('isPortal', '0');
  },
  computed: {},
  methods: {
    getCaptcha () {
      this.loading = true
      this.$http.getCaptcha()
        .then((res) => {
          this.loading = false
          this.captcha = res.data
        })
    },

    login () {
      const { captcha, code } = this
      const { userName, password } = this.loginInfo
      const params = {
        captchaKey: captcha.captchaKey,
        verificationCode: code,
        userName,
        password
      }
      if (!userName) {
        this.$message.error('账户不能为空！')
        return
      }
      if (!password) {
        this.$message.error('密码不能为空！')
        return
      }
      if (!code) {
        this.$message.error('验证码不能为空！')
        return
      }
      this.$http.login(params)
        .then((res) => {
          if (res.status === 200) {
            const { userInfoVO: { menus = [] }} = res.data
            if(!menus || !menus.length) {
              return this.$message.error('当前用户没有任何权限')
            }
            localStorage.setItem('userInfo', JSON.stringify(res.data))
            permission()
            this.$router.push('/')
          } else {
            this.$message.error(res.msg)
          }
        })
    }
  },
  watch: {}
}
</script>

<style scoped lang='scss'>
@import url("//at.alicdn.com/t/font_1728386_t8a8etb7f3h.css");
.loginbox {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("../assets/login-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  min-width: 1280px;
  .login {
    width: 1280px;
    display: flex;
    align-items: center;
    .loginimg {
      width: 750px;
      display: block;
      margin-top: 150px;
      img {
        width: 750px;
      }
    }
    ::v-deep .logininfo {
      width: 300px;
      height: 450px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 50px;
      background: #fff;
      border-radius: 15px;
      margin-left: 100px;
      .productLogo {
        margin-top: 50px;
      }
      .productTitle {
        margin-top: 20px;
      }
      & > div {
        width: 100%;
        display: block;
        text-align: center;
      }
      img {
        height: 80px;
      }
      & > {
        width: 100%;
        display: block;
        text-align: center;
        font-size: 22px;
        color: #302d30;
        margin: 20px 0 10px 0;
      }
      .el-input {
        margin-top: 20px;
      }
      .el-input__inner {
        border-radius: 6px;
        padding: 0 10px 0 35px;
      }
      .el-input__prefix {
        left: 10px;
      }
      .el-input__inner:focus {
        border-color: #5c6be8;
      }
      .el-button--primary {
        background-color: #5c6be8;
        border-color: #5c6be8;
        width: 100%;
        border-radius: 6px;
        margin-top: 20px;
      }
      .el-button--primary:hover {
        opacity: 0.85;
      }
    }
    .form-group {
      margin-top: 20px;
      justify-content: space-between;
      .groupBox {
        display: flex;
        align-items: center;
        input {
          outline: none;
          padding-left: 5px;
          box-sizing: border-box;
        }
        input::placeholder {
          font-size: 12px;
          font-family: Arial;
          letter-spacing: 1px;
          color: #ccc !important;
        }
      }
      .codeTitle {
        font-size: 12px;
        margin-top: 0;
        color: #999;
      }
      .code {
        border-radius: 5px;
        width: 124px;
        height: 31px;
        border: 1px solid rgba(186, 186, 186, 1);
      }
      .identify {
        height: 31px;
      }
    }
  }
  .footer{
    position: fixed;
    left: 50%;
    bottom: 8px;
    color: white;
    font-size: 14px;
    transform: translateX(-50%);
  }
}
</style>
